export default "__VITE_ASSET__BF7hSia2__"